import { z } from 'zod';

const isFilledLocalization = (localization: {
  text?: string;
  language?: string;
}): boolean => Boolean(localization.text && localization.language);

const isEmptyLocalization = (localization: {
  text?: string;
  language?: string;
}): boolean => !localization.text && !localization.language;

export const creativeTextLocalizationSchema = z.object({
  text: z.string(),
  language: z.string(),
});

export const creativeTextLocalizationsFieldSchema = z
  .array(creativeTextLocalizationSchema)
  .optional()
  .default([])
  .superRefine((localizations, ctx) => {
    localizations.forEach((localization, index) => {
      if (isFilledLocalization(localization) || isEmptyLocalization(localization)) {
        return;
      }

      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Please fill in all required fields in localizations',
        path: [index],
      });
    });
  });

export type CreativeTextLocalizationFormValue = z.infer<
  typeof creativeTextLocalizationSchema
>;
